/**
 * Decides whether a router navigation should be bounced to the phone-
 * verification card. The card lives on /results/loading (domestic) or
 * /results/pending (international); while the order requires verification
 * and phone_verified is false, any other destination is blocked.
 *
 * Lifted into a pure helper so it's Vitest-testable without mocking
 * vue-router / pinia.
 */

export interface PhoneVerificationGateInput {
    toPath: string;
    requiresPhoneVerification: boolean;
    phoneVerified: boolean;
    isInternational: boolean;
}

export function decidePhoneVerificationBounce(input: PhoneVerificationGateInput): string | null {
    if (!input.requiresPhoneVerification || input.phoneVerified) {
        return null;
    }

    const cardRoute = input.isInternational ? '/results/pending' : '/results/loading';

    if (input.toPath === cardRoute) {
        return null;
    }

    return cardRoute;
}
